import { MakeCall } from './createMakeCall';

type PoiDraftResponse = {
  id: string;
};

export default (makeCall: MakeCall) =>
  (data: {
    city: string;
    countryCode: string;
    description: string;
    name: string;
  }) =>
    makeCall<PoiDraftResponse>('POST', `/api/v2/poi`, {
      data,
    });
